import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    boxSizing: 'border-box',
    flexDirection: 'column'
  },
  filterButton: {
    padding: theme.spacing(2),
    color: theme.palette.secondary.light,
    '&:hover': {
      backgroundColor: 'transparent',
      color: theme.palette.primary.main
    },
    '& svg path': {
      fill: "currentColor"
    },
  },
  filterButtonOpen: {
    color: theme.palette.secondary.contrastText,
    '&:hover': {
      color: theme.palette.secondary.contrastText,
    },
  },
  menu: {
    display: 'none',
    position: 'absolute',
    left: '1rem',
    right: '1rem',
    top: '100%',
    zIndex: 100,
  },
  menuOpen: {
    display: 'block',
  },
  menuList: {
    backgroundColor: '#121212',
    border: '1px solid #333333',
    padding: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      bottom: 0,
      overflowY: 'auto',
      height: '50vh'

    },
    '& .MuiList-root': {
      padding: theme.spacing(2.5),
      '& .MuiListItem-root': {
        margin: theme.spacing(1.2),
        padding: '15px 10px',
        background: '#343434'
      },
      '& .MuiListItem-root:hover': {
        background: theme.palette.secondary.main
      }
    },
  },
  filterDropdownMenu: {
    backgroundColor: theme.palette.secondary.main,
    '& .MuiTypography-root': {
      cursor: 'pointer'
    }
  },
  filterDropdownList: {
    paddingLeft: '0px',
  },

  listItem: {
    listItemStyle: 'none',
    display: 'inline-block',
    float: 'left',
    margin: '5px',
  },
  chipItem: {
    border: '1px solid transparent',
    boxSizing: 'border-box',
  '&:hover': {
    border: '1px solid ' + theme.palette.primary.main,
    color: theme.palette.primary.main,
    fill: theme.palette.primary.main
  },
  },
  chipSelected: {
    backgroundColor: theme.palette.primary.main,
    color: 'rgba(0, 0, 0, 1)',
  '& svg path': {
    fill: 'rgba(0, 0, 0, 1)',
  },
  '&.MuiChip-clickable:focus': {
    backgroundColor: theme.palette.primary.main,
    color: 'rgba(0, 0, 0, 1)',
  },
  '&:hover svg path': {
    backgroundColor: 'rgba(255, 255, 255, 0.12)',
    border: '1px solid ' + theme.palette.primary.main,
    color: theme.palette.primary.main,
    fill: theme.palette.primary.main
  }
  },
  dropdownBtn: {
  /*'& $svg $span': {
      padding: theme.spacing(2.5)
  },*/
  '&:hover': {
    borderBottom: '2px solid #fff',
    paddingBottom: theme.spacing(1.5)
  }
  },
  filtersCount: {
    borderRadius: '50%',
    padding: '4px',
    backgroundColor: theme.palette.primary.main,
    marginLeft: '5px',
  //fontSize: '10px',
  //fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.secondary.dark,
    width: '24px'
  },
  filterMenuWrapper: {
    width: '100%',
    left: 0,
    top: 0,
    position: 'absolute'
  },
  watchedFilter: {
    "& .MuiSvgIcon-root": {
        fill: `#fff`,
    },
    "& .MuiRadio-root": {
      border: '1px solid transparent',
    },
    "& .Mui-focusVisible": {
      borderColor: theme.palette.primary.main,
    },
  },
  actionsContainer: {paddingTop: "2rem"},
  submitButton: {
    paddingTop: '1rem', 
    paddingBottom: '1rem',
  },
  clearAllButton: {
    backgroundColor: '#121212', 
    marginLeft: '1rem',
    paddingTop: '1rem', 
    paddingBottom: '1rem',
  },
  selectAllButton: {
    backgroundColor: '#121212', 
    marginLeft: '1rem',
    paddingTop: '1rem', 
    paddingBottom: '1rem',
  },
}));